module.exports = __webpack_public_path__ + "static/media/ce-sa-fac-daca-am-febra.0a3de187.jpeg";